import { ConversationData } from "./Data/ConversationData";
import { PageSectionContainer } from "../../../../Components/Styled/SectionContainer";
import { ConversationCard } from "./ConversationCard";

// add card on opposing side to explain what message is being said
// 147 - height of box /2
export const Conversation = () => {
    return (
        <PageSectionContainer
            $gap={10}
            $paddTop={5}
            id="conversation-container"
        >
            {Object.keys(ConversationData).map((Conversation) => {
                return (
                    <ConversationCard
                        cardDataObj={ConversationData[Conversation]}
                    />
                );
            })}
        </PageSectionContainer>
    );
};
